import { Component, OnDestroy, OnInit } from '@angular/core';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyPageBase } from '../../property-page-base';

@Component({
    selector: 'property-summary-page',
    templateUrl: './property-summary-page.component.html',
    styleUrls: ['./property-summary-page.component.scss']
})
export class PropertySummaryPageComponent
    extends PropertyPageBase
    implements OnInit, OnDestroy {
    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertySummary, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
